import { Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  StyledContainer,
  StyledContent,
  StyledTopBar,
  StyledFooter,
} from "./styles";
import { IconButton } from "../IconButton";
import { SidePanelProps } from "./types";

export const SidePanel = ({
  open,
  onClose,
  ariaLabel,
  rootRef,
  titleBar,
  anchor = "right",
  footer,
  closeIconPosition = "leading",
  isCloseDisabled = false,
  children,
  ...drawerProps
}: SidePanelProps) => {
  const closeTrailing = closeIconPosition === "trailing";

  return (
    <Drawer
      ref={rootRef}
      slotProps={{
        paper: {
          "aria-label": ariaLabel,
          sx: { width: "500px", maxWidth: "100vw" },
        },
      }}
      {...drawerProps}
      open={open}
      onClose={() => {
        onClose();
      }}
      anchor={anchor}
    >
      <StyledContainer>
        <StyledTopBar $closeTrailing={closeTrailing}>
          <IconButton
            onClick={onClose}
            aria-label="Close"
            disabled={isCloseDisabled}
          >
            <CloseIcon />
          </IconButton>
          {titleBar}
        </StyledTopBar>
        <StyledContent>{children}</StyledContent>
        {footer ? <StyledFooter>{footer}</StyledFooter> : null}
      </StyledContainer>
    </Drawer>
  );
};
